export const win = window;
export function onWindowClosed(window: Window, callback: () => void) {
  const timer = setInterval(() => {
    if (window.closed) {
      clearInterval(timer);
      callback();
    }
  }, 100);
}
